import { useState } from "react";
import { CustomConfirmationDialog } from "components/elements/confirmation-dialog/confirmation-dialog";
import { HELPER } from "utils/helper";
import { RECON_API } from "../../../../api/routes/back-office/reconciliation";
import { BACKOFFICE_SERVICE } from "../../../../api/services/backoffice-service";

export function DisputeInitiationConfirmation(props) {
  const [error, setError] = useState(null);
  const [responseMessage, setResponseMessage] = useState(null);
  function initiateDisputeCreation() {
    let params = {
      disputeDate: props.transactionDate,
    };
    BACKOFFICE_SERVICE.MAKE_PUT_REQUEST(
      RECON_API.INITIATE_DISPUTE_ON_FAILED_TRANSACTIONS,
      null,
      HELPER.TO_URL_STRING(params)
    )
      .then((data) => {
        setResponseMessage(data?.result?.message);
      })
      .catch((error) => {
        setError(HELPER.PROCESS_ERROR(error));
      });
  }

  function reinitiateDisputeCreation() {
    let params = {
      date: props.transactionDate,
    };
    BACKOFFICE_SERVICE.MAKE_PUT_REQUEST(
      RECON_API.REINITIATE_DISPUTE_ON_FAILED_TRANSACTIONS,
      null,
      HELPER.TO_URL_STRING(params)
    )
      .then((data) => {
        setResponseMessage(data?.result?.message);
      })
      .catch((error) => {
        setError(HELPER.PROCESS_ERROR(error));
      });
  }

  function closeModal(reload) {
    props.closeModal(reload);
  }

  return (
    <CustomConfirmationDialog
      text={`Confirm that you want to ${
        props.isRefresh
          ? "..."
          : "initiate a dispute on all failed transactions?"
      }`}
      action={
        props.isRefresh ? reinitiateDisputeCreation : initiateDisputeCreation
      }
      errorMessage={error}
      clearErrorMessage={() => setError(null)}
      responseMessage={responseMessage}
      closeModal={closeModal}
    />
  );
}
